<template>
  <div class="search-location">
    <gmap-autocomplete
      class="a-input autocomplete"
      :value="query"
      :placeholder="$ml.get(`Enter location`)"
      @place_changed="setPlace"
      :select-first-on-enter="true">
    </gmap-autocomplete>
  </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
export default {
  data() {
    return {
      query: '',
      place: null,
    }
  },
  created() {

  },
  methods: {
    setPlace(place) {
      let latLng = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
      }
      this.$emit('setPlace', latLng)
    }
  },
}
</script>

<style lang="scss" scoped>
.search-location {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 401;
  > input {
    height: 32px;
    padding: 0 12px;
    outline: none;
    font-size: 16px;
    border: 1px solid $mainGreen;
    border-radius: 3px;
    border-style: solid;
    background-color: #fff;
    color: $mainGreen;
    box-shadow: 0 0 0 transparent;
    transition: -webkit-box-shadow 0.1s ease;
    transition: box-shadow 0.1s ease;
    &:focus {
      box-shadow: 0 0 0 4px rgba(111, 156, 64, 0.2);
    }
  }
  @media(max-width: 768px) {
    > input {
      max-width: 160px;
    }
  }
}
</style>
